import i18n from 'config/i18n';
import * as yup from 'yup';

import { getLocale } from 'utils/date';

const stringToFloat = (value, originalValue) => {
  return Number(originalValue.toString().replace(',', '.'));
};

const getSchema = () => {
  const t = i18n.getFixedT(getLocale(), 'common');

  const addressSchema = yup
    .object({
      street: yup
        .string()
        .required(t('validationFieldRequired', { name: t('street') })),
      houseNumber: yup
        .string()
        .required(t('validationFieldRequired', { name: t('houseNumber') })),
      postalCode: yup
        .string()
        .required(t('validationFieldRequired', { name: t('postalCode') })),
      city: yup
        .string()
        .required(t('validationFieldRequired', { name: t('city') })),
      countryCode: yup
        .string()
        .required(t('validationFormRequired', { name: 'country' }))
    })
    .required();

  return yup.object({
    departureAddress: addressSchema,
    destinationAddress: addressSchema,
    distanceInMeters: yup
      .number()
      .transform(stringToFloat)
      .required(
        t('validationFieldRequired', { name: t('travelDistances.distance') })
      ),
    travelTimeInSeconds: yup.number().transform(stringToFloat),
    transportationMode: yup.string().required(
      t('validationFieldRequired', {
        name: t('travelDistances.transportationMode')
      })
    ),
    routeCalculationType: yup.string().required(
      t('validationFieldRequired', {
        name: t('travelDistances.routeCalculationType')
      })
    )
  });
};

export default getSchema;
